var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRss(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 32,
    viewBox: "0 0 30 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "RSS Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape",
    d: "M3 25.4794C4.65685 25.4794 6 26.8225 6 28.4794C6 30.1362 4.65685 31.4794 3 31.4794C1.34315 31.4794 0 30.1362 0 28.4794C0 26.8225 1.34315 25.4794 3 25.4794ZM2.87695 13.4852C7.46944 13.3753 11.1808 14.6939 13.9175 17.4564C16.6453 20.21 18.0014 23.9394 18 28.557C17.9994 29.3429 17.368 29.9796 16.5894 29.9794C15.8105 29.9791 15.18 29.3417 15.1802 28.5555C15.1813 24.6561 14.0904 21.6562 11.9238 19.4691C9.76613 17.2911 6.8042 16.2391 2.94434 16.3314C2.16575 16.3501 1.51854 15.7287 1.5 14.9428C1.48153 14.1568 2.09832 13.5039 2.87695 13.4852ZM2.87695 1.49109C11.1767 1.29219 17.8157 3.65056 22.6992 8.58387C27.5737 13.5083 30.0023 20.1944 30 28.5541C29.9998 29.341 29.3682 29.9794 28.5894 29.9794C27.8104 29.9791 27.1786 29.341 27.1787 28.5541C27.181 20.9129 25.0175 14.957 20.7041 10.5995C16.3997 6.25121 10.5114 4.15893 2.94434 4.34022C2.16576 4.35887 1.51884 3.73653 1.5 2.95008C1.48153 2.16335 2.09822 1.50985 2.87695 1.49109Z",
    fill: "#FAF1E6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRss);
export default __webpack_public_path__ + "static/media/rss.073592665cc50f77622f2058b4e24015.svg";
export { ForwardRef as ReactComponent };